export class Event {
    Name: string;
    StageId?: number;
    ReferenceIdentifier?: string;
    Properties: any;
    messages?: EventMessage[];
}
export class EventMessage {
    operation: string;
    status: string;
    message: string;
}
